import { useEffect, useRef, useState } from 'react';

const getCurrentDiff = (date: Date) => new Date(date).valueOf() - new Date().valueOf();

const useDateIsBelow = (date: Date, limit: number) => {
  const timeoutRef = useRef<number | undefined>(undefined);
  const diff = getCurrentDiff(date);
  const dateIsBelow = diff < limit;

  const [isBelow, setIsBelow] = useState(dateIsBelow);

  useEffect(() => {
    const currentDiff = getCurrentDiff(date);
    if (currentDiff > limit) {
      const timoutTime = currentDiff - limit;
      timeoutRef.current = setTimeout(() => {
        setIsBelow(true);
      }, timoutTime) as unknown as number;
    }
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [date, limit]);

  return isBelow;
};

export default useDateIsBelow;
